// "مهامي" لحسابات البوكسات (الجديدة - مثل تيهان): نفس صفحة مهام الموظفات
// باسم الموظفة الظاهر. السيرفر يفرض نفس الاسم (resolveUserIdentity) فما
// تكدر تشوف مهام غيرها.
import React from "react";
import KarinaTasks from "./KarinaTasks";
import { getCurrentProfile, isBoxAccount } from "./utils/userProfile";

// لأي حساب ممنوح بوكس "مهامي" (حتى الحسابات القديمة): السيرفر يرجّع مهام
// الموظف نفسه بس، والاسم هنا للعرض فقط
const MyTasks = () => (
  <KarinaTasks
    employeeName={getCurrentProfile().displayName}
    backPath={isBoxAccount() ? "/workspace" : "/"}
  />
);

export default MyTasks;
